var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProperties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92057 2.40332L17.8563 8.85909V37.5004H1.42773V8.8517L9.92057 2.40332ZM2.14202 9.20621V36.7861H17.142V9.19881L9.90534 3.31173L2.14202 9.20621Z",
    fill: "#807E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6423 13.767H11.7852V13.0527H14.6423V13.767Z",
    fill: "#807E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49972 13.767H4.64258V13.0527H7.49972V13.767Z",
    fill: "#807E8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6423 20.0004H11.7852V19.2861H14.6423V20.0004Z",
    fill: "#807E8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6423 26.2338H11.7852V25.5195H14.6423V26.2338Z",
    fill: "#807E8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6423 32.4682H11.7852V31.7539H14.6423V32.4682Z",
    fill: "#807E8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49972 20.0004H4.64258V19.2861H7.49972V20.0004Z",
    fill: "#807E8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49972 26.2338H4.64258V25.5195H7.49972V26.2338Z",
    fill: "#807E8D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49972 32.4682H4.64258V31.7539H7.49972V32.4682Z",
    fill: "#807E8D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59961 37.1431V2.85742H10.3139V37.1431H9.59961Z",
    fill: "#807E8D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1426 16.5264H33.5712V37.5004H17.1426V16.5264ZM17.8569 17.2407V36.7861H32.8569V17.2407H17.8569Z",
    fill: "#807E8D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.356 24.6753L20.356 20L21.0703 20L21.0703 24.6753L20.356 24.6753Z",
    fill: "#807E8D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6412 24.6753L24.6412 20L25.3555 20L25.3555 24.6753L24.6412 24.6753Z",
    fill: "#807E8D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9283 24.6753L28.9283 20L29.6426 20L29.6426 24.6753L28.9283 24.6753Z",
    fill: "#807E8D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.356 32.4683L20.356 27.793L21.0703 27.793L21.0703 32.4683L20.356 32.4683Z",
    fill: "#807E8D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6412 32.4683L24.6412 27.793L25.3555 27.793L25.3555 32.4683L24.6412 32.4683Z",
    fill: "#807E8D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9283 32.4683L28.9283 27.793L29.6426 27.793L29.6426 32.4683L28.9283 32.4683Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProperties);
export default __webpack_public_path__ + "static/media/no-properties.0963790a.svg";
export { ForwardRef as ReactComponent };